import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import axios_api from '../Api';

import { API_URL, AUTH_TOKEN } from '../Context';
import { otherTicketBlock } from '../blocks';
import Loader from './common/Loader';


// Фильтр по статусу временно отключен
// const STATUS_FILTER_OPTIONS = [
//   { value: '', label: 'Все' },
//   { value: 'opened', label: 'Открытые' },
//   { value: 'closed', label: 'Закрытые' },
// ];


function Ticket({ticket, block}){
  const ticketLink = <Link to={`${block.path}/tickets/${ticket.id}`}>Обращение № {ticket.id}</Link>;

  return (
    <p>
      {ticket.viewed === true ? ticketLink : <b>{ticketLink}</b>}
      {ticket.theme?.theme_name ? ` — ${ticket.theme.theme_name}` : ''}
      {ticket.status === 'CLOSED' ? ' — закрыто' : ''}
    </p>
  )
}


export default function Tickets ({selectedYear, block}){
  const[tickets, setTickets] = useState([]);
  // const[statusFilter, setStatusFilter] = useState('');
  const[loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const otherBlock = otherTicketBlock(block);

  React.useEffect(() => {
    let ignore = false;
    setLoading(true);

    let userTickets = axios_api.get(api_url + '/user_tickets/', {
      headers: {"Authorization": token},
      params: {
        "year": selectedYear,
        // "status": statusFilter || undefined,
      }
    });

    userTickets.then(
      (result) => {
        if (!ignore) {
          setTickets(result.data);
          setLoading(false);
        }
      },
      (error) => {
        console.log(error)
        if (!ignore) {
          setLoading(false);
        }
      }
    );

    return () => {
      ignore = true;
    };
  }, [api_url, token, selectedYear /*, statusFilter */]);

  // API отдает обращения всех очередей, в блоке показываем только его очередь
  const rows = tickets
    .filter(ticket => ticket.queue === block.ticketQueue)
    .map(ticket =>
      <Ticket 
        key={ticket.id} 
        ticket={ticket}
        block={block}
      />
    );

  return (
    <>
      <div className="row">
        <h3 className="m-3">{block.ticketsTitle}</h3>
      </div>
      <div className="d-flex flex-wrap gap-3 m-3 mb-5">
        <button className='btn lk-button' onClick={() => navigate(`${block.path}/tickets/new`)}>Создать обращение</button>
        <button className='btn btn-outline-primary lk-bootstrap-button lk-outline-soft-button' onClick={() => navigate(`${otherBlock.path}/tickets`)}>
          {otherBlock.ticketsTitle}<i className="bi bi-arrow-right ms-2"></i>
        </button>
      </div>
      {/*
      <div className="d-flex gap-3 m-3 mt-4 align-items-center">
        <label htmlFor="ticketStatusFilter" className="form-label fw-semibold mb-0">Статус:</label>
        <select
          id="ticketStatusFilter"
          className="form-select"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          style={{maxWidth: '300px'}}
        >
          {STATUS_FILTER_OPTIONS.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </div>
      */}
      <div className="row m-3">
        {loading ?
          <Loader/>
        :
          rows.length ? rows : <p className="text-secondary">Обращений нет</p>
        }
      </div>
    </>
  )
}
